// extracted by mini-css-extract-plugin
export default {"headerOption":"HeaderOption_headerOption__dtAPN","title":"HeaderOption_title__decuI","avatar":"HeaderOption_avatar__hJPB0","icon":"HeaderOption_icon__CK0cE"};